import classNames from "classnames";
import * as React from "react";

import Button, { Props as ButtonProps } from "../../Button";
import styles from "./PrimaryButton.module.scss";
import typeStyles from "./PrimaryButtonTypes.module.scss";

export const TYPES = {
  check: "check",
  negative: "negative",
  positive: "positive",
  positiveLight: "positive--light",
  medium: "medium",
  malibu: "malibu",
  skyBlue: "skyBlue",
  carnation: "carnation",
  smallText: "smallText"
};

export type PrimaryButtonColorProps = Omit<ButtonProps, "type"> & {
  type?: string[];
  className?: string;
  stayPressed?: boolean;
  shimmer?: boolean;
};

export type Props = PrimaryButtonColorProps & {
  primaryButtonColorClassName?: string; // used by PrimaryButtonWhite etc.
};

export default function PrimaryButton({
  type,
  primaryButtonColorClassName,
  className,
  stayPressed,
  disabled,
  shimmer,
  ...otherProps
}: Props) {
  const typesClassNames = getTypesClassNames(type);
  return (
    // @ts-ignore
    <Button
      {...otherProps}
      buttonClassName={classNames(
        styles.primaryButton,
        ...typesClassNames,
        primaryButtonColorClassName,
        className,
        {
          [styles.stayPressed]: stayPressed,
          [styles.shimmer]: shimmer
        }
      )}
      disabled={stayPressed || disabled}
      dataTest={otherProps.dataTest || "PrimaryButton"}
    />
  );
}

function getTypesClassNames(types?: string[]) {
  return types ? types.map(type => typeStyles[type]) : [];
}
